import PillarForm from "shared/components/pillar-form/PillarForm";
import { useCustomSession } from "shared/context/CustomSessionContext";
import { formatUsdString } from "shared/helpers/invoice/formatUsdString";
import { StorePageRouteParams } from "shared/types/HubPageRouteParams";
import { GridProduct } from "hub/src/components/store/ProductGrid";
import { getLowestPrice } from "hub/src/utils/getLowestPrice";

type ProductGridItemProps = {
  product: GridProduct;
  index: number;
  onClickBuy: (product: GridProduct) => void;
  onClickViewDetails: (product: GridProduct) => void;
  cardClassName?: string;
  imageWrapperClassName?: string;
  imageClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  classNames?: StorePageRouteParams["classNames"];
};

const ProductGridItem = ({
  product,
  index,
  onClickBuy,
  onClickViewDetails,
  classNames,
}: ProductGridItemProps) => {
  const session = useCustomSession();

  return (
    <div
      key={product.productId}
      data-testid={`product-${index}`}
      className={`mx-auto px-4 pt-3 pb-2 w-full flex flex-col rounded cursor-pointer text-center border border-neutral-mid-250 shadow-md ${classNames?.card ?? ""}`}
      onClick={() => onClickViewDetails(product)}
    >
      {product.image ? (
        <div
          className={`mb-2 w-full h-auto min-md:h-28 min-2xl:h-33 ${classNames?.imageWrapper ?? ""}`}
        >
          <img
            src={product.image}
            alt={product.name}
            className={`w-full h-full aspect-[1.3] object-contain rounded-md max-h-full ${classNames?.image ?? ""}`}
          />
        </div>
      ) : (
        <div
          className={`mb-2 w-full h-28 bg-primary-200 flex items-center justify-center ${classNames?.imagePlaceholder ?? ""}`}
        >
          No Image
        </div>
      )}
      <h2
        className={`mb-2 text-xl font-semibold line-clamp-2 ${classNames?.title ?? ""}`}
      >
        {product.name}
      </h2>
      <p
        className={`mb-auto text-start line-clamp-6 ${classNames?.description}`}
      >
        {product.description}
      </p>
      <div className="mt-2 flex items-center justify-between">
        <p className="text-lg font-semibold">
          {formatUsdString(getLowestPrice(product, session.tags ?? []))}
        </p>
        <PillarForm.LoadingButton
          onClick={async (event) => {
            event.stopPropagation();
            await onClickBuy(product);
          }}
          className={`min-w-lg w-fit bg-society-200 hover:bg-society-300 text-white ${
            !product.available ? "cursor-not-allowed" : ""
          } ${classNames?.action ?? ""}`}
          data-testid={`buy-now-button-${product.productId}`}
          disabled={!product.available}
        >
          {product.available ? "Buy Now" : "Out of Stock"}
        </PillarForm.LoadingButton>
      </div>
    </div>
  );
};

export default ProductGridItem;
